import React, { memo } from 'react'

import { bool } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { parseRunIdFromPathname } from 'Pods/ThreeDStudio/Hooks/parseRunIdFromPathname'
import useIsWatchingGeneratingRun from 'Pods/ThreeDStudio/Hooks/useIsWatchingGeneratingRun'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import LoadingBanner from '../LoadingBanner/LoadingBanner'
import CleverPushOptInRow from './Components/CleverPushOptInRow/CleverPushOptInRow'
import RelatedProducts from './Components/RelatedProducts/RelatedProducts'

// Picks the loading variant from the URL: a model-detail URL means we're
// hydrating that run ("Loading 3D model"); anything else means the user is
// watching their own generation ("Generating your 3D model"). The watched run takes
// precedence so users who started a generation keep the generating copy even though
// the post-completion history.replace will move them onto a model-detail URL.
function LoadingBannerState({ forceSharedRun = false }) {
  const t = useTranslation()
  const location = useLocation()
  const isWatchingGeneratingRun = useIsWatchingGeneratingRun()
  const urlHasModelId = parseRunIdFromPathname(location?.pathname ?? '') != null
  const isSharedRunView = forceSharedRun || (urlHasModelId && !isWatchingGeneratingRun)

  return (
    <LoadingBanner
      title={isSharedRunView ? t('viewer.banner.loadingTitle') : t('viewer.banner.generatingTitle')}
      description={isSharedRunView ? null : t('viewer.banner.generatingDescription')}
      contentChildren={isSharedRunView ? null : <CleverPushOptInRow />}
    >
      {!isSharedRunView && <RelatedProducts />}
    </LoadingBanner>
  )
}

LoadingBannerState.propTypes = {
  forceSharedRun: bool,
}

export default memo(LoadingBannerState)
